import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { useEffect, useState } from "react";
import useInterval from "utils/useInterval";

//시스템 이용현황 모니터링
export default function SystemMonitoringComponent() {
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  useInterval(() => {
    getData();
  }, 60000);

  const getData = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.getSystemMonitoringList();
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    })
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard">
        <div class="top_board pc">
          <p class="title_board">시스템 이용현황 모니터링</p>
          <div class="wrap_search">
            <div class="box_search">
              <div class="wrap_userCount">
                <div class="wrap_totalUsers">
                  <p class="title_total">총 가입자 수 </p>
                  <p class="title_total">{dataSource.totalUsers}명</p>
                </div>
                <div class="wrap_onlineUsers">
                  <div class="title_total">
                    현재 <p class="num_total">{dataSource.currentOnline}</p>
                    명 접속 중
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src="/images/my_btn_mb.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb" >
          <Link class="wrap_navi" to="/">
            <p class="title_navi">시스템 이용현황 모니터링</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="wrap_search mb_wrap_count mb">
          <div class="box_search">
            <div class="select_box">
              <button class="btn_select">
                <p>항목</p>
                <i class="x-icon"></i>
              </button>
              <ul class="list_member">
                <li>
                  <p>1</p>
                </li>
                <li>
                  <p>2</p>
                </li>
                <li>
                  <p>3</p>
                </li>
              </ul>
            </div>
            <div class="wrap_userCount">
              <div class="wrap_totalUsers">
                <p class="title_total">총 가입자 수 </p>
                <p class="title_total">1,343명</p>
              </div>
              <div class="wrap_onlineUsers">
                <div class="title_total">
                  현재 <p class="num_total">643</p>
                  명 접속 중
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="chart_board">
          <div className="wrap_chart">
            <p className="title_chart">Today 시간별 이용자 수</p>
            <div className="box_chart">
              <div className="wrap_canvas">
                {dataSource.hourlyToday && (
                  <ReactApexChart
                    options={{
                      chart: {
                        type: 'bar',
                        height: 360,
                        toolbar: {
                          show: false
                        }
                      },
                      xaxis: {
                        categories: dataSource.hourlyToday.map((item) => item.hour)
                      },
                      plotOptions: {
                        bar: {
                          horizontal: false,
                          endingShape: 'rounded',
                          columnWidth: '55%'
                        }
                      },
                      colors: ['#4b75ff'],
                      dataLabels: {
                        enabled: false
                      },
                      legend: {
                        show: false
                      }
                    }}
                    series={[
                      {
                        name: "이용자 수",
                        type: "column",
                        data: dataSource.hourlyToday.map((item) => item.count),
                      }
                    ]}
                    type="bar"
                    height={360}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="wrap_chart">
            <p className="title_chart">최근 1년 월별 이용자 수</p>
            <div className="box_chart">
              <div className="wrap_canvas">
                {dataSource.monthlyLastYear && (
                  <ReactApexChart
                    options={{
                      chart: {
                        type: 'line',
                        height: 360,
                        toolbar: {
                          show: false
                        }
                      },
                      xaxis: {
                        categories: dataSource.monthlyLastYear.map((item) => item.month)
                      },
                      colors: ['#4b75ff'],
                      dataLabels: {
                        enabled: false
                      },
                      legend: {
                        show: false
                      },
                      stroke: {
                        curve: 'straight',
                        width: 8
                      }
                    }}
                    series={[
                      {
                        name: "이용자 수",
                        type: "line",
                        data: dataSource.monthlyLastYear.map((item) => item.count),
                      }
                    ]}
                    type="line"
                    height={360}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
